import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EmpGrievanceHttpService } from '../emp-grievance-http.service';
import { startWith, map } from 'rxjs';
import { AlertComponent } from 'src/app/alert/alert.component';

@Component({
  selector: 'app-super-admin-dialog',
  templateUrl: './super-admin-dialog.component.html',
  styleUrls: ['./super-admin-dialog.component.scss']
})
export class SuperAdminDialogComponent implements OnInit {
  stateFilter: any = new FormControl("");
  zoneFilter: any = new FormControl("");
  cityFilter: any = new FormControl("");
  campusFilter: any = new FormControl("");
  selectedState: any = ""
  selectedCampus: any = ""
  selectedCity: any = ""
  selectedZone: any = ""
  stateOptions: any;
  states: any;
  zones: any;
  zoneOptions: any;
  cityOptions: any;
  cities: any;
  campuses: any;
  campusOptions: any;

  constructor(private dialogRef: MatDialogRef<SuperAdminDialogComponent>, private service: EmpGrievanceHttpService ,private dialog:MatDialog) { }
  ngOnInit(): void {
    this.getState()
  }

  getState() {
    this.service.getEmpStates().subscribe({
      next: (res: any) => {
        console.log(res);
        this.states = res
        this.stateOptions = this.stateFilter.valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.states, 'stateName'))
        )
      },
      error: (err: any) => {
        console.log(err)
      }
    })
  }

  getZones(state: any) {
    this.selectedState=state
    console.log(state)
    this.clearZone()
    this.service.getStateZones(state.stateId).subscribe({
      next: (res: any) => {
        console.log(res);
        this.zones = res
        this.zoneOptions = this.zoneFilter.valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.zones, 'zoneName'))
        )
        console.log(this.zoneOptions)
      },
      error: (err: any) => {
        console.log(err)
      }
    })
  }

  getCitites(zone: any) {
    console.log(zone)
    this.clearCity()
    this.selectedZone=zone
    this.service.getZoneCities(zone.zoneName).subscribe({
      next: (res: any) => {
        console.log(res);
        this.cities = res
        this.cityOptions = this.cityFilter.valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.cities, 'cityName'))
        )
      },
      error: (err: any) => {
        console.log(err)
      }
    })
  }

  getCampus(city: any) {
    console.log(city)
    this.clearCampus()
    this.selectedCity=city
    this.service.getCityCampuses(city.cityId).subscribe({
      next: (res: any) => {
        console.log(res);
        this.campuses = res
        this.campusOptions = this.campusFilter.valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.campuses, 'campusName'))
        )
      },
      error: (err: any) => {
        console.log(err)
      }
    })
  }

  selectCampus(campus:any){
    this.selectedCampus =campus
  }

  private Filter(value: string, list: any[], name: any): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].toString().trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
  }

clearCampus() {
  this.selectedCampus = null;
  this.campusFilter.patchValue('');
}
clearCity() {
  this.selectedCity = null;
  this.cityFilter.patchValue('');
  this.clearCampus()
}

clearZone() {
  this.selectedZone = null;
  this.zoneFilter.patchValue('');
  this.clearCity()
}


  closeDilaog(data: any) {
    if (data == 'search') {
      if(this.selectedCampus || this.selectedCity || this.selectedState || this.selectedZone){
        const data = {
        state: this.selectedState,
        zone:this.selectedZone,
        city:this.selectedCity,
        campus:this.selectedCampus,
        status: 'search'
      }
      this.dialogRef.close(data)
      }
      else {
        this.dialog.open(AlertComponent,{
          width: '400px',
          position: { right: '20px', top: '20px' },
          data: { 
            data:"Please select state  to search ",
            status:"Warning"
          }
        })
      }
    }
    else {
      this.dialogRef.close()
    }
  }
}
